module.exports = __webpack_public_path__ + "img/chris.3f7bbb2f.jpeg";